import { isString } from "lodash";
import { Doc, DocAdd, DocTypeEnum } from "../types/doc";
import { isDoc, isEnum, isStringEmpty } from "../utils/checkTool";
import request from ".";
import { cleanToDoc } from "../utils/cleanData";

const DOC_URL = '/wms/doc';

const DOC_APIS = {
    add: DOC_URL + `/add`,
    disable: (id: string) => DOC_URL + `/${id}/disable`,
    get: (id: string) => DOC_URL + `/${id}/get`,
    fetch: (id: string) => DOC_URL + `/${id}/fetch`,
    fetchs: DOC_URL + '/fetchs',
    updatePid: (id: string) => `${DOC_URL}/${id}/pid/update`
}

export const docAdd = (doc: DocAdd) => {
    if ((doc.pId && !isString(doc.pId)) ||
        !isString(doc.name) || isStringEmpty(doc.name) ||
        (doc.suffix && !isString(doc.suffix)) ||
        (doc.fileId && !isString(doc.fileId)) ||
        !isEnum(doc.nodeType, DocTypeEnum)) {
        return Promise.reject(10012)
    }
    return request<Doc, DocAdd>(DOC_APIS.add, { params: { body: doc } })
        .then(({ body: info }) => {
            if (isDoc(info)) {
                return Promise.resolve(cleanToDoc(info))
            } else {
                return Promise.reject(10013)
            }
        })
        .catch(err => Promise.reject(err))
}

export const docDisable = (id: string) => {
    if (!isString(id) || isStringEmpty(id)) {
        return Promise.reject(10012)
    }
    return request<void>(DOC_APIS.disable(id))
}

export const docGet = (id: string) => {
    if (!isString(id) || isStringEmpty(id)) {
        return Promise.reject(10012)
    }
    return request<Doc, string>(DOC_APIS.get(id))
        .then(({ body: doc }) => {
            if (isDoc(doc)) {
                return Promise.resolve(cleanToDoc(doc))
            } else {
                return Promise.reject(10013)
            }
        })
        .catch(err => Promise.reject(err))
}

export const docFetch = (id: string) => {
    if (!isString(id) || isStringEmpty(id)) {
        return Promise.reject(10012)
    }
    return request<Doc, string>(DOC_APIS.fetch(id))
        .then(({ body: doc }) => {
            if (isDoc(doc)) {
                return Promise.resolve(cleanToDoc(doc))
            } else {
                return Promise.reject(10013)
            }
        })
        .catch(err => Promise.reject(err))
}

export const docFetchs = (ids: string[]) => {
    if (!ids || ids.length <= 0) {
        return Promise.reject(10012)
    }
    return request<Doc[], string[]>(DOC_APIS.fetchs, { params: { body: ids } })
        .then(({ body: docs }) => {
            if (docs && docs.length > 0) {
                let docDatas: Doc[] = []
                docs.forEach(item => {
                    if (isDoc(item)) docDatas.push(cleanToDoc(item))
                })
                return Promise.resolve(docDatas)
            } else return Promise.reject(10013)
        })
        .catch(err => Promise.reject(err))
}

export const updatePid = (id: string, targetId: string) => {
    return new Promise<Doc>((resolve, rejevt) => {
        request<Doc, string>(DOC_APIS.updatePid(id), { params: { body: targetId } })
            .then(res => resolve(res.body))
            .catch(err => rejevt(err))
    })
}